import React from 'react';

const MenuPrincipalStyles = () => {
  return (
    <style>
      {`
        /* Estilos generales del menú */
        .ant-menu-dark {
          background: transparent !important;
        }

        .ant-menu-dark.ant-menu-inline .ant-menu-item,
        .ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
          color: rgba(255, 255, 255, 0.9) !important;
          border-radius: 8px !important;
          margin: 4px 8px !important;
        }

        .ant-menu-dark.ant-menu-inline .ant-menu-item:hover,
        .ant-menu-dark.ant-menu-inline .ant-menu-submenu-title:hover {
          background: rgba(255, 255, 255, 0.15) !important;
          color: white !important;
        }

        .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title {
          background: rgba(255, 255, 255, 0.1) !important;
          color: white !important;
        }

        /* Estilos específicos para submenús */
        .ant-menu-dark .ant-menu-sub.ant-menu-inline {
          background: linear-gradient(135deg, rgba(74, 90, 207, 0.4) 0%, rgba(37, 50, 137, 0.6) 100%) !important;
          border-radius: 12px !important;
          margin: 8px 8px !important;
          padding: 8px !important;
          backdrop-filter: blur(10px) !important;
          border: 1px solid rgba(255, 255, 255, 0.15) !important;
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 2px 8px rgba(0, 0, 0, 0.2) !important;
        }

        .ant-menu-dark .ant-menu-sub .ant-menu-item {
          background: rgba(255, 255, 255, 0.08) !important;
          color: rgba(255, 255, 255, 0.95) !important;
          border-radius: 8px !important;
          margin: 4px 4px !important;
          padding: 8px 12px !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
          transition: all 0.3s ease !important;
          height: auto !important;
          line-height: 1.4 !important;
        }

        .ant-menu-dark .ant-menu-sub .ant-menu-item:hover {
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.15) 100%) !important;
          color: white !important;
          transform: translateX(2px) !important;
          border-color: rgba(255, 255, 255, 0.3) !important;
          box-shadow: 0 2px 8px rgba(255, 255, 255, 0.1) !important;
        }

        .ant-menu-dark .ant-menu-sub .ant-menu-item a {
          color: rgba(255, 255, 255, 0.95) !important;
          font-weight: 400 !important;
          transition: all 0.3s ease !important;
          display: block !important;
          width: 100% !important;
          text-decoration: none !important;
        }

        .ant-menu-dark .ant-menu-sub .ant-menu-item:hover a {
          color: white !important;
          font-weight: 500 !important;
        }

        /* Iconos de los submenús */
        .ant-menu-dark .ant-menu-sub .ant-menu-item .anticon {
          margin-right: 8px !important;
          font-size: 14px !important;
          display: inline-block !important;
          vertical-align: middle !important;
          color: rgba(255, 255, 255, 0.9) !important;
          transition: color 0.3s ease !important;
        }

        .ant-menu-dark .ant-menu-sub .ant-menu-item:hover .anticon {
          color: white !important;
        }

        .ant-menu-dark .ant-menu-sub .ant-menu-item span {
          display: inline-block !important;
          vertical-align: middle !important;
        }

        .ant-menu-dark .ant-menu-item-selected {
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%) !important;
          color: white !important;
          border-radius: 8px !important;
          box-shadow: 0 2px 8px rgba(255, 255, 255, 0.15) !important;
        }

        .ant-menu-dark .ant-menu-item-selected a {
          color: white !important;
          font-weight: 600 !important;
        }

        .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title {
          background: rgba(255, 255, 255, 0.15) !important;
          color: white !important;
        }

        .ant-menu-dark .ant-menu-submenu-arrow {
          color: rgba(255, 255, 255, 0.8) !important;
          transition: all 0.3s ease !important;
        }

        .ant-menu-dark .ant-menu-submenu-open .ant-menu-submenu-arrow {
          color: white !important;
        }

        /* Asegurar que el texto no se corte */
        .ant-menu-dark .ant-menu-submenu-title,
        .ant-menu-dark .ant-menu-item {
          white-space: nowrap !important;
          overflow: visible !important;
          text-overflow: ellipsis !important;
        }

        .ant-menu-dark .ant-menu-submenu-title span,
        .ant-menu-dark .ant-menu-item span {
          white-space: nowrap !important;
        }
      `}
    </style>
  );
};

export default MenuPrincipalStyles;